/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
/**
 * The internal dependencies.
 */
import Button from '../../components/general/button';
import Chevron from '../../components/general/navigation-chevron';

const Wrapper = styled(Button)`
	display: flex;
	align-items: center;
	justify-content: center;

	width: ${({width}) => width ? width : '178px'};
	font-size: ${({fontSize}) => fontSize ? fontSize : '14px'};
	border-width: ${({border}) => border ? border : '2px'};
	background: #fff;

	color: #686871;
	border-color: #686871;

	& span {
		position: absolute;
		${({chevronPosition}) => chevronPosition
    ? chevronPosition
    : `
				top: 11px;
				left: 16px;
			`
    }
		border-color: #686871;
	}

	&:hover {
		background: #9B9B9B;
	}
`;

const BackButton = ({
                        handleClick,
                        width,
                        border,
                        chevronPosition,
                        chevronSize,
                        fontSize,
                        text,
                    }) => (
    <Wrapper
        onClick={handleClick}
        width={width}
        border={border}
        chevronPosition={chevronPosition}
        fontSize={fontSize}
    >
        <Chevron rotate={-135} size={chevronSize}/>

        {text}
    </Wrapper>
);

export default BackButton;



// WEBPACK FOOTER //
// ./src/components/general/back-button.js